// // Styles
import { flexParent } from "../../../utilities/Mixin.styles";
export const customFacepileStyles = {
    root: [
        flexParent()
    ],
    members: {
        margin: "6px",
        "& > .ms-Facepile-itemButton": {
            margin: "6px"
        }
    },
    descriptiveOverflowButton: {
        "& > .ms-Button-flexContainer > span": {
            display: "none"
        },
        "&.ms-Facepile-itemButton": {
            marginLeft: "12px"
        }
    }
};
